import Api from './api.js';
import axios from 'axios';

export class EditorialApi extends Api {
    constructor(options = {}) {
        super(options);

        this.editoialApiPath = 'editorials';
    }

    async getEditorialList(){
        return await this.axiosInstance.request({
            method: 'get',
            url: this.editoialApiPath,
        });
    }
}
